import { MenuButtonItem } from 'components/MenuButton';
import {
  StyledDynamicIssueTypeOption,
  StyledDynamicIssueTypes
} from './DynamicIssueTypes.style';
import useIssueTypes from 'common/fetchHooks/pmProvider/useIssueTypes';
import useIssueTypesList from './useIssueTypesList';
import Loader from './Loader';
import ShowMoreToggler from './ShowMoreToggler';
import { useState } from 'react';

const DynamicIssueTypes = ({ onClick, isActive }) => {
  const [selectedIssueType, setSelectedIssueType] = useState(null);
  const { issueTypes, isLoading } = useIssueTypes();
  const { issueTypesInView, shouldShowMore, showMore, showLess } =
    useIssueTypesList({
      issueTypes
    });

  const onClickIssueType = issueType => {
    setSelectedIssueType(issueType);
    onClick({
      customFetchProps: { issueType }
    });
  };

  if (isLoading) return <Loader />;
  if (!issueTypesInView?.length) return null;

  return (
    <StyledDynamicIssueTypes>
      {issueTypesInView.map(({ issue_type }) => {
        const isSelected = isActive && selectedIssueType === issue_type;
        return (
          <StyledDynamicIssueTypeOption key={issue_type}>
            <MenuButtonItem
              id={issue_type}
              text={issue_type}
              isActive={isSelected}
              onClick={() => onClickIssueType(issue_type)}
            />
          </StyledDynamicIssueTypeOption>
        );
      })}
      {shouldShowMore && (
        <ShowMoreToggler
          showMore={showMore}
          showLess={showLess}
          isShowMore={issueTypesInView.length < issueTypes.length}
        />
      )}
    </StyledDynamicIssueTypes>
  );
};

export default DynamicIssueTypes;
